// extracted by mini-css-extract-plugin
export var drawerPaper = "_1o-0";
export var itemCard = "_1o-1";
export var itemImage = "_1o-2";